import { tokens } from '@fluentui/react-components';
import { AccessType } from '@modules/access/types';
import { ESubmissionItemStatus } from './types/submissions.types';

/**
 * FULL_PATH_SUBMISSIONS_ITEM
 * ---------------------------------
 * Represents the submissions module item in the navigation hierarchy.
 * This is used in components such as the navigation drawer.
 */
export const FULL_PATH_SUBMISSIONS_ITEM = Object.freeze({
  _id: 'submissions',
  name: 'Submissions',
  accessRight: AccessType.NONE,
});

export const ARCHIVED_JURISDICTION_VIRTUAL_ID = 'archived-jurisdictions-filter-id';

export const SUBMISSION_STATUS_COLORS_MAP: Record<ESubmissionItemStatus, string> = {
  // Both "in progress" and "in review" are Microsoft's accent blue
  [ESubmissionItemStatus.IN_PROGRESS]: '#3174C2',
  [ESubmissionItemStatus.IN_REVIEW]: '#3174C2',
  [ESubmissionItemStatus.ACCEPTED]: tokens.colorBrandForeground1, // Brand green
  [ESubmissionItemStatus.BACKLOG]: tokens.colorNeutralForeground1, // Neutral gray
};

export const ALL_SUBMISSION_ITEM_STATES = Object.values(ESubmissionItemStatus);
